export default __webpack_public_path__ + "static/media/undraw_cookie_love_ulvn.382b304b.svg";